/* eslint camelcase: 0 */
import common from './common/en_US';
import dappsMaker from './dapps-maker/en_US';
import dappsSubmission from './dapps-submission/en_US';
import home from './home/en_US';
import howItWorks from './how-it-works/en_US.json';
import footer from './footer/en_US';
import gettingStarted from './getting-started/en_US';
import privacyPolicy from './privacy-policy/en_US';
import termsOfService from './terms-of-conditions/en_US';
import accessWallet from './access-wallet/en_US';
import interfaceTranslations from './interface/en_US';
import errorsGlobal from './errors-global/en_US';
import trezorError from './errors-trezor/en_US';
import bcvaultError from './errors-bcvault/en_US';
import coolWalletError from './errors-coolwallet/en_US';
import ledgerError from './errors-ledger/en_US';
import keepkeyError from './errors-keepkey/en_US';
import bitboxError from './errors-bitbox/en_US';
import bitbox02Error from './errors-bitbox02/en_US';
import buyHardwareWallet from './other/buy-hardware-wallet/en_US';
import convertUnits from './other/convert-units/en_US';
import verifyMessage from './other/verify-message/en_US';
import sendTx from './send-tx/en_US';
import ens from './dapps-ens/en_US';
import unstoppable from './dapps-unstoppable/en_US';
import subDomain from './dapps-sub-domain/en_US';
import scheduleTx from './dapps-schedule-tx/en_US';
import nftManager from './nft-manager/en_US';
import signMessage from './sign-message/en_US';
import ambrpay from './dapps-ambrpay/en_US';
import phishing from './other/phishing/en_US';
import aave from './dapps-aave/en_US';
import header from './header/en_US';
import mcdMaker from './dapps-mcd-maker/en_US';
import dappsStaked from './dapps-staked/en_US';

const en_US = {
  common: common,
  home: home,
  howItWorks: howItWorks,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfService: termsOfService,
  accessWallet: accessWallet,
  interface: interfaceTranslations,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  coolWalletError: coolWalletError,
  ledgerError: ledgerError,
  bcvaultError: bcvaultError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError,
  bitbox02Error: bitbox02Error,
  buyHardwareWallet: buyHardwareWallet,
  dappsMaker: dappsMaker,
  convertUnits: convertUnits,
  verifyMessage: verifyMessage,
  sendTx: sendTx,
  ens: ens,
  unstoppable: unstoppable,
  subDomain: subDomain,
  scheduleTx: scheduleTx,
  nftManager: nftManager,
  signMessage: signMessage,
  dappsSubmission: dappsSubmission,
  ambrpay: ambrpay,
  phishing: phishing,
  aave: aave,
  header: header,
  mcdMaker: mcdMaker,
  dappsStaked: dappsStaked
};
export default en_US;
